<div class="body_container">
  <div class="listHeader" style="margin-bottom: 5px">
    <h4 style="margin: 0px">Local Repository List</h4>
  </div>
  <as-split direction="horizontal">
    <as-split-area [size]="detailsViewOpen ? 20 : 100">
      <div class="right-panel h-100">
        <div class="right-side">
          <div class="sessionList d-flex flex-column h-100">
            <div class="actionBar d-flex">
              <input
                class="search"
                type="text"
                placeholder="Search by name or IP Address"
                [(ngModel)]="filterText"
                (ngModelChange)="onSearch()"
              />
              <button
                type="button"
                title="Migrate Repository from HuggingFace"
                class="actionBtn"
                style="float: right"
                (click)="addLocalRepo()"
              >
                <span class="bi bi-download"></span>
              </button>
              <button
                type="button"
                title="Add user to Gitea"
                class="actionBtn"
                style="float: right"
                (click)="createGiteaUser()"
              >
                <span class="bi bi-person-fill-up"></span>
              </button>
              <button
                type="button"
                title="Registered user on Gitea"
                class="actionBtn"
                style="float: right"
                (click)="showRegisteredUsers()"
              >
                <span class="bi bi-person"></span>
              </button>
              <button
                type="button"
                title="Refresh"
                class="actionBtn"
                style="float: right"
                (click)="loadGiteaRepo()"
              >
                <span class="bi bi-arrow-clockwise"></span>
              </button>
              <button
                type="button"
                title="Self Hosted Repository"
                class="actionBtn"
                (click)="goToRepohub()"
                style="float: right"
              >
                <Span>
                  <img
                    style="width: 25px"
                    src="assets/images/syncious/gitea.svg"
                    alt="Gitea Logo"
                  />
                </Span>
              </button>
            </div>

            <div class="listTable h-100">
              <div
                class="x w-100"
                [class.h-100]="isDataAvailable"
                style="overflow-y: auto"
              >
                <table
                  cellspacing="0"
                  class="table table-hover table-condensed"
                  style="border-collapse: collapse; white-space: nowrap"
                >
                  <thead class="cursor-default">
                    <tr
                      style="
                        color: White;
                        background-color: var(--s-primary-color);
                        height: 22px;
                      "
                    >
                      <th resizable scope="col">#</th>
                      <th resizable scope="col">
                        Name
                        <span style="cursor: pointer" class="bi"></span>
                      </th>
                      <th resizable scope="col">
                        Size
                        <span style="cursor: pointer" class="bi"></span>
                      </th>
                      <th resizable scope="col">
                        Owner
                        <span style="cursor: pointer" class="bi"></span>
                      </th>
                      <th resizable scope="col">
                        Last Modified
                        <span style="cursor: pointer" class="bi"></span>
                      </th>
                      <th resizable scope="col">
                        Created At
                        <span style="cursor: pointer" class="bi"></span>
                      </th>
                      <th
                        resizable
                        scope="col"
                        class="text-center"
                        *ngIf="!isMonitor && isGlobalAdmin"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="hpc-cursor-pointer table-list-row"
                      *ngFor="let repo of filteredRepoList; let i = index"
                    >
                      <td scope="row" *ngIf="p == 1">{{ i + 1 }}</td>
                      <td scope="row" *ngIf="p != 1">
                        {{ (p - 1) * 10 + (i + 1) }}
                      </td>
                      <td
                        [title]="repo.name"
                        class="cursor-pointer impListName"
                        (click)="togglePodView(repo)"
                      >
                        {{ repo.name }}
                        <span
                          style="cursor: pointer"
                          (click)="redirectTo(repo)"
                          class="value"
                        >
                          <span class="value"
                            ><i class="bi bi-box-arrow-up-right"></i></span
                        ></span>
                      </td>
                      <td>{{ repo.size }} KB</td>
                      <td>{{ repo.owner.username }}</td>
                      <td>{{ repo.updatedAt | date : "medium" }}</td>
                      <td>{{ repo.createdAt | date : "medium" }}</td>
                      <td
                        class="text-center"
                        *ngIf="!isMonitor && isGlobalAdmin"
                      >
                        <button
                          type="button"
                          class="actionBtn"
                          triggers="hover"
                          ngbTooltip="Add Collaborators"
                          (click)="addCollaboratorToRepo(repo)"
                        >
                          <span class="bi bi-person-plus"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <pagination-controls
                  *ngIf="filteredRepoList && filteredRepoList.length > 10"
                  class="my-pagination"
                  (pageChange)="p = $event"
                >
                </pagination-controls>
              </div>
            </div>
          </div>
        </div>
        <p
          class="hpc-error-message-list"
          style="margin: auto auto"
          *ngIf="isDataAvailable == false"
        >
          No Local Repository Found.
        </p>
        <ngx-spinner
          bdColor="rgba(0,0,0,0)"
          size="default"
          zIndex="1"
          color="var(--s-primary-color)"
          type="ball-spin"
          [fullScreen]="false"
          name="repoListSpinner"
        >
          <p class="pleaseWait">Please wait ...</p>
        </ngx-spinner>
      </div>
    </as-split-area>
    <as-split-area [size]="detailsViewOpen ? 80 : 0" *ngIf="detailsViewOpen">
      <app-repo-advance-view
        (closeModal)="closeRepoDetails()"
      ></app-repo-advance-view>
    </as-split-area>
  </as-split>
</div>
